// extracted by mini-css-extract-plugin
module.exports = {"cardDiv":"card_cardDiv__34wJF"};